import { render, staticRenderFns } from "./SignUp.vue?vue&type=template&id=1944b3af&scoped=true"
import script from "./SignUp.vue?vue&type=script&lang=js"
export * from "./SignUp.vue?vue&type=script&lang=js"
import style0 from "./SignUp.vue?vue&type=style&index=0&id=1944b3af&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1944b3af",
  null
  
)

export default component.exports